export const debugLogVariables = (msg: string, variables: object) => {
  const logMessage = [""];
  for (const [name, value] of Object.entries(variables)) {
    logMessage.push(`${name}:`, value);
  }
  console.group(msg);
  console.debug(...logMessage);
  console.groupEnd();
};
